import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import type { jhMenu_jhMenu_children_children } from 'src/queries/__generated__/jhMenu';

import { Svg } from '../Svg/Svg';

import classes from './NavSub.scss';

type NavSubProps = {
    hideShopAll: boolean;
    parentTitle: string;
    parentUrl: string;
    setOverflow?: (value: boolean) => void;
    showSub: boolean;
    subNavs: (jhMenu_jhMenu_children_children | null)[];
    toggleList(value);
};

export const NavSubSub = React.memo(function NavSub(props: NavSubProps) {
    const { subNavs, parentTitle, showSub, toggleList, setOverflow } = props;
    return (
        <div className={classes.navSub} data-subnav-active={String(showSub)} data-nav-overflow={String(showSub)}>
            <span className={classes.navSubHeader}>
                <button
                    className={classes.navSubHeaderBack}
                    onClick={() => {
                        toggleList(-1);
                        setOverflow?.(true);
                    }}
                    type="button"
                >
                    <Svg name="arrow-left" />
                    Back
                </button>
                <h2 className={classes.navSubHeaderTitle}>{parentTitle}</h2>
            </span>
            <ul className={classes.navSubList}>
                {!props.hideShopAll && (
                    <li className={classes.navSubItem}>
                        <Link
                            to={props.parentUrl}
                            className={classnames({
                                [classes.navSubLink]: true,
                                [classes.navSubAll]: true,
                            })}
                        >
                            Shop All {parentTitle}
                        </Link>
                    </li>
                )}
                {subNavs.map((item, index) => {
                    if (!item) {
                        return null;
                    }

                    const isUrl = item.type === 'custom_url' || item.type === 'category';

                    return (
                        <li key={`${item.title}-${index}`} className={classes.navSubItem}>
                            {isUrl && (
                                <Link to={item.url ?? ''} className={classes.navSubLink}>
                                    {item.title}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
});
